const applyFiltersAndSort = (
  listings,
  priceRange,
  conditions,
  bookTypes,
  selectedSchools,
  sortBy,
  courseCode
) => {
  return listings
    .filter(listing => {
      // Filter by price range
      const priceInRange = listing.price >= priceRange[0] && listing.price <= priceRange[1];

      // Filter by conditions
      const conditionMatch = conditions.length === 0 || conditions.includes(listing.condition);

      // Filter by book types
      const typeMatch = bookTypes.length === 0 || bookTypes.includes(listing.bookType);

      // Filter by schools
      const schoolMatch = selectedSchools.length === 0 || selectedSchools.includes(listing.seller);

      // Filter by course code
      const courseMatch = courseCode === 'all' || 
        (listing.courseCode && listing.courseCode.toLowerCase().includes(courseCode.toLowerCase()));

      return priceInRange && conditionMatch && typeMatch && schoolMatch && courseMatch;
    })
    .sort((a, b) => {
      switch (sortBy) {
        case 'Price Low to High':
          return a.price - b.price;
        case 'Price High to Low':
          return b.price - a.price;
        case 'Like New to Worn':
          const conditionOrder = { 'Like New': 0, 'Good': 1, 'Worn': 2 };
          return conditionOrder[a.condition] - conditionOrder[b.condition];
        case 'Worn to Like New':
          const reverseConditionOrder = { 'Like New': 2, 'Good': 1, 'Worn': 0 };
          return reverseConditionOrder[a.condition] - reverseConditionOrder[b.condition];
        default:
          return 0;
      }
    });
};

export default applyFiltersAndSort;